let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bxAxf")).then(() => parcelRequire('2TK39'));